import { BrowserRouter } from "react-router-dom";
import { ThemeProvider } from "@material-ui/core/styles";
import "./App.css";
import Container from "./components/Container";
import TourOverlay from "./tour/TourOverlay";

function App() {
  return (
    <div className="App">
      {/* DEV ENVIRONMENT BANNER - Only shows in development */}
      {process.env.REACT_APP_ENV === 'development' && (
        <div style={{
          background: 'linear-gradient(90deg, #ff6b6b 0%, #ee5a6f 100%)',
          color: 'white',
          padding: '12px 20px',
          textAlign: 'center',
          fontWeight: 'bold',
          fontSize: '14px',
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
          position: 'fixed',
          top: '10px',
          left: '50%',
          transform: 'translateX(-50%)',
          zIndex: 9999,
          borderRadius: '8px',
          maxWidth: 'fit-content',
          whiteSpace: 'nowrap'
        }}>
          🚧 DEV ENVIRONMENT 🚧 | ace.v2.aizatroncloud.com
        </div>
      )}

      <BrowserRouter>
        <ThemeProvider>
          <TourOverlay />
          <Container
            style={{
              paddingLeft: 0,
              paddingRight: 0,
              overflow: "hidden",
              maxWidth: "100vw",
            }}
          >
            {/* The Routes and Route components were removed as they are not present in the original file.
                 If they are intended to be added, they should be re-added here. */}
          </Container>
        </ThemeProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;